<template>
  <div class="wrapper">
    <div class="header-wrapper">
      <div class="header">社区报到</div>
      <div class="addManager">
        <Button class="bkcc-btn" @click="exportFile">导出</Button>
        <Button class="bkcc-btn" @click="loadData">搜索</Button>
        <Button class="bkcc-btn" @click="searchReset">重置</Button>
      </div>
    </div>
    
    <div class="content">
      <Card>
        <i-form ref="searchForm" :model="query">
          <row :gutter="20">
            <i-col span="6">
              <form-item label="姓名" prop="name">
                <i-input
                  v-model="query.name"
                  clearable
                  placeholder="请填写姓名"
                />
              </form-item>
            </i-col>

            <i-col span="6">
              <form-item label="身份证号" prop="cardno">
                <i-input
                  v-model="query.cardno"
                  clearable
                  placeholder="请填写身份证号"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="手机号" prop="tel">
                <i-input
                  v-model="query.tel"
                  clearable
                  placeholder="请填写手机号"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="职务/职级" prop="position">
                <i-input
                  v-model="query.position"
                  clearable
                  placeholder="请填写职务/职级"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="审核状态" prop="state">
                <Select v-model="query.state" style="width:100%" clearable>
                  <Option v-for="item in stateList" :value="item.value" :key="item.value">{{ item.name }}</Option>
                </Select>
              </form-item>
            </i-col>
          </row>
          
        </i-form>
      </Card>
      <Card class="card" style="margin-top: 20px">
        <Table border :columns="columns" :data="data" :loading="loading"></Table>
        <div class="page">
          <Page :total="total" :current="pageNum" @on-page-size-change="changePageSize" show-total :page-size="pageSize" :page-size-opts="[10,15,20,50,100,200]" @on-change="page" show-sizer/>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
var that;
import miment from "miment";
import { Page } from "view-design";
const querystring = require("querystring");
export default {
  components:{
    Page
  },
  data() {
    return {
      stateList:[{
          name:'待审核',
          value:1
        },
        {
          name:'审核完成',
          value:0
        }
      ],
      query: {
        name: "",
        cardno: "",
        position:'',
        tel: "",
        state: "",
      },
      columns: [
        {
          title: "姓名",
          key: "name",
          width:110
        },
        {
          title: "身份证号",
          key: "cardno",
          width:190
        },
        {
          title: "手机号",
          key: "tel",
          width:135
        },
        {
          title: "职务/职级",
          key: "position"
        },
        {
          title: "具体地址",
          key: "address"
        },
        {
          title: "提交时间",
          key: "createTime",
          width:160
        },
        // {
        //   title: "修改时间",
        //   key: "updateTime",
        //   width:160
        // },
        {
          title: "状态",
          key: "state",
          width:110,
          render:function(h, params) {
            return h("div",{
              style:{
                color:params.row.state==1 ? '' : 'rgb(0, 195, 255)'
              }
            },params.row.state==1 ? '待审核' : '审核成功')
          }
        },
        {
          title: "操作",
          width:100,
          render: function(h, params) {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    color: "#5e6d94"
                  },
                  props:{
                    disabled:params.row.state!=1,
                    type:"dashed"
                  },
                  on: {
                    click: () => {
                      that.audit(params);
                    }
                  }
                },
                "审核"
              ),
            ]);
          }
        }
      ],
      pageNum: 1,
      pageSize: 10,
      data:[],
      loading: true,
      total: 0,
    };
  },
  computed: {
    
  },
  methods: {
    
    async exportFile(){
      let url = this.urlobj.registrationExportJczlRegistrationRecord
       try {
        const exportConfigs = [
          {
            url: `${url}?${querystring.stringify(this.query)}&token=${this.$store.state.access_token}`,
            name: '社区报到.xlsx'
          },
        ];
        
        // 顺序下载
        for (const config of exportConfigs) {
          await this.downloadFileWithName(config.url, config.name);
        }
        
        this.$Message.success('文件导出成功！');
      } catch (error) {
        console.error('导出失败:', error);
        this.$Message.error('文件导出失败！');
      }
    },
    downloadFileWithName(url, fileName) {
      return new Promise((resolve, reject) => {
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.style.display = 'none';
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        setTimeout(resolve, 500); // 添加延迟确保下载开始
      });
    },
    audit(params){
      this.$Modal.confirm({
        title:'审核确认',
        content:`是否进行用户（${params.row.name}） 社区报到审核`,
        onOk: () => {
          this.auditRequest(params.row.id)
        }
      })
    },
    auditRequest(id){
      let url = this.urlobj.reviewRecordJczlRegistrationRecord;
      this.$get(url,{
        id:id
      })
      .then(res => {
        if (res.isSucceed) {
          this.loadData();
        }else{
          this.$Modal.confirm({
            title: "提示",
            content: res.message
          });
        }
      })
    },
    searchReset(){
      this.pageNum = 1
      this.pageSize = 10
      this.$refs.searchForm.resetFields();
      this.loadData();
    },
    loadData(){
      this.loading = true
      let url = this.urlobj.getJczlRegistrationRecordPcList;
      var data = { 
        page: this.pageNum,
        rows: this.pageSize,
        ...this.query
      };
      this.$get(url,data)
      .then(res => {
        this.data = res.rows.map(item=>{
          return {
            ...item,
            createTime:miment(item.createTime).format("YYYY-MM-DD hh:mm"),
            updateTime:miment(item.updateTime).format("YYYY-MM-DD hh:mm"),
          }
        })
        this.total = res.total
        if (!res.isSucceed) {
          this.$Modal.confirm({
            title: "提示",
            content: res.message
          });
        }
        this.loading=false
      })
      .catch(e => {
        console.error(e)
        this.loading=false
      })
    },

    changePageSize(val){
      this.pageSize = val
      this.loadData()
    },
    page(val) {
      this.pageNum = val;
      this.loadData()
    },
    
  },
  mounted() {
    this.loadData()
  },
  created() {
    that = this;
  }
};
</script>
<style lang='less' scoped>
.wrapper {
  color: #666666;
  height: 100%;
}

.wrapper::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  /* height: 4px; */
}
.header-wrapper {
  display: flex;
  justify-content: center;
  height: 84px;
  line-height: 84px;
  position: relative;
}
.header {
  font-size: 25px;
  text-align: center;
}
.addManager {
  position: absolute;
  right: 20px;
}
.content {
  //   @content();
  // max-width: 96%;
  margin: 20px;
  margin-top: 0;
  // background: #fff;
  // padding: 0 15px 0 15px;
  &::-webkit-scrollbar {
    display: none;
  }
  .select-wrapper {
    font-size: 16px;
    margin-bottom: 20px;
    .name {
      margin-bottom: 10px;
    }
    .input {
      width: 30%;
    }
  }
  .card {
    height: 100%;
  }
  /deep/ .ivu-table-overflowX {
    overflow-x: hidden !important;
  }
}
.search {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
}
.table-tabs {
  max-width: 100%;
  padding: 0;
  margin-top: 30px;

  /deep/ .ivu-tabs-bar {
    margin-bottom: 0;
    border-bottom: 0;
  }
  /deep/ .ivu-tabs-tab-active {
    color: white;
    background: #fe7d43;
    border-radius: 5px 5px 0 0;
  }
  /deep/ .ivu-tabs-ink-bar {
    height: 0px;
  }
  /deep/ .ivu-tabs-nav {
    padding-left: 10px;
    color: black;
  }
}

.table-data {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  min-height: calc(100vh - 450px);
}
.page {
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
.code-img {
  margin: 20px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  // width: 172px;
  height: 172px;
  img {
    width: 172px;
    height: 172px;
  }
}
.text {
  font-size: 16px;
  span {
    text-decoration: underline;
    color: #fe7d43;
  }
}
/deep/ .ivu-table-tip table td{
  width: 100% !important;
}
/deep/ th .ivu-table-cell span {
  font-weight: bold !important;
}
</style>